var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResponsiveImage',_vm._b({staticClass:"c-cloudinary-image",style:({ 'aspect-ratio': _vm.aspectRatio })},'ResponsiveImage',Object.assign({}, _vm.$attrs, {src: _vm.src, srcset: _vm.srcset}),false))}
var staticRenderFns = []

export { render, staticRenderFns }